import { Mail, Clock, MessageSquare } from 'lucide-react';

export default function Contact() {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <section className="text-center py-12">
        <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
          <MessageSquare className="w-4 h-4" />
          Contact Us
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Get in Touch</h1>
        <p className="text-xl text-gray-500 max-w-xl mx-auto">
          Have a question, suggestion, or need support? We'd love to hear from you.
        </p>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {/* Info cards */}
        <div className="space-y-6 md:col-span-1">
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
            <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center mb-4">
              <Mail className="w-5 h-5 text-blue-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">Email Us</h3>
            <p className="text-sm text-gray-500 mb-2">For all enquiries, please reach out to:</p>
            <a
              href="mailto:contactus@varbiz.co.uk"
              className="text-blue-600 font-medium text-sm hover:underline break-all"
            >
              contactus@varbiz.co.uk
            </a>
          </div>

          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
            <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center mb-4">
              <Clock className="w-5 h-5 text-green-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">Response Time</h3>
            <p className="text-sm text-gray-500">
              We aim to respond to all enquiries within <span className="font-medium text-gray-700">1–2 business days</span>.
            </p>
          </div>

          <div className="bg-blue-600 rounded-xl p-6 text-white">
            <h3 className="font-semibold mb-2">VarBiz Ltd</h3>
            <p className="text-blue-100 text-sm leading-relaxed">
              Parent company of RemindMeOf.<br />
              Registered in the United Kingdom.<br />
              Building intelligent tools for the world.
            </p>
          </div>
        </div>

        {/* Contact form */}
        <div className="md:col-span-2 bg-white rounded-xl border border-gray-100 shadow-sm p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Send Us a Message</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              window.location.href = 'mailto:contactus@varbiz.co.uk';
            }}
            className="space-y-5"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                <input
                  type="text"
                  placeholder="Jane"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                <input
                  type="text"
                  placeholder="Smith"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input
                type="email"
                placeholder="jane@example.com"
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-700">
                <option value="">Select a topic…</option>
                <option value="support">General Support</option>
                <option value="billing">Billing Enquiry</option>
                <option value="feedback">Product Feedback</option>
                <option value="privacy">Privacy / Data Request</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea
                rows={5}
                placeholder="How can we help you?"
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              />
            </div>
            <p className="text-xs text-gray-400">
              By submitting this form your message will be sent to{' '}
              <a href="mailto:contactus@varbiz.co.uk" className="text-blue-500 hover:underline">
                contactus@varbiz.co.uk
              </a>
              . We'll reply as soon as possible.
            </p>
            <button type="submit" className="btn-primary w-full py-3">
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* FAQ teaser */}
      <section className="bg-gray-50 rounded-2xl p-8 mb-12 text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Looking for quick answers?</h2>
        <p className="text-gray-500 text-sm">
          Many common questions about account management, reminders, and notifications are answered right inside the app.
          Sign in and visit your profile settings for help with your account.
        </p>
      </section>
    </div>
  );
}
